import { Module } from 'vuex';
import { RootState } from '@/store/types';
import { StatisticState } from './types';
import { actions } from './actions';
import { mutations } from './mutations';
import { getters } from './getters';

export const state: StatisticState = {
    customStatisticDetail: [],
    customStatisticGroup: [],
    customStatisticGroupMessageCount: 0,
    customGroupings: {
        customGroup: [
            'hour',
            'day',
            'week',
            'month',
        ],
        customGroupByOptionally: [
            'partner',
            'service_provider',
            'message_category',
            'originator',
            'template_id',
            'bulk_id',
            'broker_account_login',
            'message_type',
        ],
    },
};

export const customStatistic: Module<StatisticState, RootState> = {
    state,
    getters,
    actions,
    mutations
};
